import classnames from 'classnames';
import {
  ActivateDialog,
  PisDialog,
  SubscribeDialog,
  UseVoucherDialog,
} from 'components/glampartners/Dialogs';
import { StatusInfo } from 'components/glampartners/StatusInfo';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { UiActions } from 'state/actions/UiActions';
import { PartnerInfoActions } from 'state/actions/user/PartnerInfoActions';
import { PartnerResultsActions } from 'state/actions/user/PartnerResultsActions';
import { ExecuteToggle } from 'state/ducks/Modals';
import { CurrentPeriod } from 'types/CurrentPeriod';
import { CopyToClipBoard } from 'utils/CopyToClipBoard';
import { Utils } from 'utils/Utils';
import PartnerStyles from 'views/development/PartnerStyles.module.scss';
import { GlamboxCookieStore } from 'core/glambox/GlamboxCookieStore';
import { Modal } from 'components/modal/Modal';

import { GlamstarView } from 'assets/data/glamstarBannerView.jsx';
import Style from 'views/pages/PlanoDeDesenvolvimento.module.scss';

export class PortalGlampartners extends React.Component {
  constructor(props) {
    super(props);


    this.state = {
      results: {
        glamboxPayment: 0,
        glamshopPayment: 0,
        b4APayment: 0,
        totalToPay: 0,
        loaded: false
      },
      salesInfo: {},
      personalUseCoupon: null,
      influencerEnabled: false,
      influencerStatus: null,
      subscribers: {
        id: null,
        subscriptionTypeId: null,
      },
      GlamstarViewVisible: false,
      currentDetails: null,
    };
    this.cookieHandle = new GlamboxCookieStore();
  }

  getStatus = async () => {
    await ExecuteRequest(
      GlamboxEndpoints.Partner.getPartnerGeneral,
      null,
      'GET',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      response => {
        const statusEnabled = response.result.GlampartnerInfos[0].enabled;
        const influencerStatusId =
          response.result.GlampartnerInfos[0].influencerStatus;
        this.setState({
          influencerStatus: influencerStatusId,
        });

        if (statusEnabled) {
          this.setState({
            influencerEnabled: true,
          });
        }
      }
    );
  };

  componentDidMount() {
    this.getStatus();
    this.props.getCurrentResults();
    this.getPersonalUseCoupon();

    if (this.props.subscribers.length !== 0) {
      this.setState({
        subscribers: {
          id: this.props.subscribers[0].id,
          subscriptionTypeId: this.props.subscribers[0].id,
        },
      });
    }

    if(this.props.partnerResults){
      this.setState({
        results: this.props.partnerResults
      });
    }
  }

  componentDidUpdate(prevProps) {
    console.log(prevProps.partnerResults);
    console.log(this.props.partnerResults !== null);
    console.log(this.props.partnerResults != undefined);
    if (!prevProps.partnerResults && this.props.partnerResults !== null && this.props.partnerResults != undefined) {
      this.updateResults();
    }
  }

  updateResults = () => {
    const { partnerResults } = this.props;
    // console.log(partnerResults);
    if (partnerResults) {
      this.setState({
        results: partnerResults,
      });
    }
  };

  _enableInfluencer = () => {
    this.props.loaderShow();

    ExecuteRequest(
      GlamboxEndpoints.Partner.enable,
      null,
      'POST',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      response => {
        this.props.loaderHide();

        let { statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            influencerEnabled: true,
          });

          this.props.publishSuccessAlert(
            'Você foi ativada com sucesso no programa Glampartners!'
          );

          // TODO: IDENTIFY

          this.props.identifyTokenAndPersonId(
            this.props.token.Authorization,
            this.props.token.personId
          );

          this.forceUpdate();
        }
        // } else {
        //   this.props.publishErrorAlert(
        //     "Erro ao ativar sua assinatura no programa Glampartners."
        //   );
        // }
      }
    );
  };

  getPersonalUseCoupon = () => {
    const { token } = this.props;

    ExecuteRequest(
      GlamboxEndpoints.Subscriber.personalUseCoupon,
      null,
      'GET',
      {
        Authorization: token.Authorization,
      },
      null,
      response => {
        let { result, statusCode } = response;
        if (statusCode === 200) {
          this.setState({
            personalUseCoupon: result.coupon,
          });
        }
      }
    );
  };

  renderGpCard = () => {
    const { partnerInfo } = this.props;

    return (
      <div className={PartnerStyles['card']}>
        <div
          className={
            'd-flex align-items-center ' + PartnerStyles['partner-card']
          }
        >
          <div className={PartnerStyles['avatar']}>
            {partnerInfo.influencerStatus === 'Glampartner VIP' && (
              <img
                style={{ maxWidth: '150px' }}
                src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19453.png"
                alt="Jóia GP VIP"
              />
            )}
            {partnerInfo.influencerStatus === 'Glampartner' && (
              <img
                style={{ maxWidth: '150px' }}
                src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19454.png"
                alt="Jóia GP"
              />
            )}
            <br />
            <small>
              <NavLink className={'linkAnchor'} to={'/glampartner/faq/#niveis'}>
                Explore o portal para melhorar seus resultados!
              </NavLink>
            </small>
          </div>
          <div className={PartnerStyles['partner']}>
            <h3 className={PartnerStyles['name']}>
              {partnerInfo.name.toLowerCase()}
            </h3>
            <StatusInfo />
          </div>
        </div>
      </div>
    );
  };

  renderAboutProgram = () => {
    return (
      <div className={PartnerStyles['about-container']}>
        <div className={PartnerStyles['card']}>
          <div className={PartnerStyles['about']}></div>
        </div>
      </div>
    );
  };

  renderCouponCard = () => {
    const { person } = this.props;
    const pageLink = 'glampartner';

    return (
      <div className={PartnerStyles['card']}>
        <div className={PartnerStyles['coupon-card']}>
          <div className={PartnerStyles['coupon-title']}>
            <img
              src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19452.png"
              alt=""
            />
            <h3>Cupom</h3>
          </div>
        </div>
        <p>Seu cupom para divulgar Assinaturas e Produtos</p>
        <div className={PartnerStyles['coupon-content']}>
          {/* conteudo */}
          <div
            className={classnames(
              PartnerStyles['coupon-item'],
              PartnerStyles['coupon-item-dashed']
            )}
            onClick={this.editCoupon}
            id={'couponName'}
          >
            <p>{person.person.couponName}</p>
          </div>
          <div
            className={classnames(
              PartnerStyles['coupon-item'],
              PartnerStyles['coupon-item-link'],
              PartnerStyles['coupon-item-dashed']
            )}
            id="couponLink"
          >
            <p>
              https://glambox.com.br/promocoes/assinaturas?cupom={person.person.couponName}
              {/* https://sua.glambox.com.br/{pageLink}/?c=
              {person.person.couponName} */}
            </p>
          </div>

          {/* botoes */}
          <div
            className={classnames(
              PartnerStyles['coupon-item'],
              'btn btn-light-pink'
            )}
            onClick={this.copyToClipBoard('couponName', this.props)}
          >
            <p>Copiar cupom </p>
          </div>
          <div
            onClick={this.copyToClipBoard('couponLink', this.props)}
            id={'copy'}
            className={classnames(
              PartnerStyles['coupon-item'],
              'btn btn-light-pink'
            )}
          >
            {/* <CopyIcon size={24} fill={"#fff"} /> */}
            <p>Copiar link Glambox </p>
          </div>
        </div>
      </div>
    );
  };

  copyToClipBoard = (id, props) => {
    return event => {
      event.preventDefault();
      CopyToClipBoard.copyToClipBoard(id, props);
    };
  };

  editCoupon = () => {
    this.props.toggle('coupon');
  };

  verifyVoucher = async () => {
    let data = {
      voucherNumber: this.props.partnerInfo.number,
      voucherProvider: 1,
    };

    let response = await ExecuteRequest(
      GlamboxEndpoints.Open.voucherCheck,
      data,
      'POST',
      null,
      null
    );

    let { statusCode } = response;

    if (statusCode === 200) {
      this.cookieHandle.set(
        'gbVoucher',
        data.voucherNumber
        //JSON.stringify(response.result.voucher)
      );

      this.props.toggle('createWithVoucher');
    } else {
      this.props.publishErrorAlert('Erro ao verificar dados do voucher.');
    }
  };

  renderRemuneracao = () => {
    const { results } = this.state;
    const currentPeriod = new CurrentPeriod();
    return (
      <div className={PartnerStyles['card']}>
        <div className={PartnerStyles['payment-card']}>
          <div className={PartnerStyles['payment-title']}>
            <img
              alt=""
              src={
                'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19451.png'
              }
            />
            <h3>Remuneração</h3>
          </div>
          <p className={PartnerStyles['reference']}>Sua remuneração do mês</p>
          <div className={PartnerStyles['current-payment']}>
            <p className={PartnerStyles['reference']}>
              <strong style={{ textTransform: 'capitalize' }}>
                {currentPeriod.monthLong}/{currentPeriod.year}
              </strong>
            </p>
            <p className={PartnerStyles['current-value']}>
              {/* {JSON.stringify(this.state.results.loaded)} */}
              { this.state.results && this.state.results.loaded ? Utils.toCurrency(results.totalToPay) : 'carregando...' }
            </p>
          </div>
          <div className={PartnerStyles['payments']}>
            {this.renderEachPayment()}
          </div>
        </div>
      </div>
    );
  };

  renderEachPayment = () => {
    const { results } = this.state;

    return (
      <>
        <div className={PartnerStyles['payment']}>
          <p>Assinaturas</p>
          <p className={PartnerStyles['value']}>
            {Utils.toCurrency(results.glamboxPayment)}
          </p>
        </div>
        <div className={PartnerStyles['payment']}>
          <p>Produtos</p>
          <p className={PartnerStyles['value']}>
            {Utils.toCurrency(results.glamshopPayment)}
            {/* R${results.glamshopPayment.toString().replaceAll(".", ",")}0 */}
          </p>
        </div>
        <div className={PartnerStyles['payment']}>
          <p>Publis</p>
          <p className={PartnerStyles['value']}>
            {Utils.toCurrency(results.b4APayment)}
          </p>
        </div>
      </>
    );
  };

  Modal = item => {
    this.setState({
      currentDetails: item,
      GlamstarViewVisible: !this.state.GlamstarViewVisible,
    });
  };

  render() {
    const { currentDetails } = this.state;
    const { partnerInfo, person, partnerGeneral, token } = this.props;
    if (!partnerInfo || !person || !partnerGeneral) return null;

    const { personalUseCoupon, influencerEnabled, influencerStatus } =
      this.state;

    let isPISExists = !(
      !this.props.partnerInfo.pis ||
      this.props.partnerInfo.pis === ' ' ||
      this.props.partnerInfo.pis === undefined ||
      this.props.partnerInfo.pis === null
    );

    let voucherCanBeUsed =
      partnerInfo.voucherStatusName === 'Enabled' &&
      influencerEnabled &&
      influencerStatus !== 'Glampartner' &&
      influencerStatus !== 'Glamdiva' &&
      influencerStatus !== 'Glamqueen';

    return (
      <div className={'py-2 px-2 px-lg-0 py-lg-5 home'}>
        <Helmet>
          <title>Portal Glampartners</title>
        </Helmet>
        <h2>
          Portal <span>Glam</span>partners
        </h2>
        <div className={PartnerStyles['welcome-container']}>
          <h3>Seja bem-vinda, Glampartner!</h3>
          {/* <p>
            Queremos te ajudar a dar os primeiros passos como influenciadora
            digital e incentivar que você continue crescendo em direção aos seus
            objetivos!
          </p>
          <p>
            Sendo uma Glampartner, você representa as nossas marcas e o Universo
            Glam para a sua audiência e, em troca, ganha renda extra, recebe
            prêmios e ganha benefícios exclusivos.
          </p> */}
        </div>

         <NavLink
          className={PartnerStyles.bannerWrapper}
          to="/glampartner/glamstar/desafios"
        >
          <div className={PartnerStyles.banner}></div>
        </NavLink> 

        <div className={PartnerStyles['partner-container']}>
          {!partnerInfo.enabled && !influencerEnabled && (
            <ActivateDialog onClick={this._enableInfluencer} />
          )}
          {personalUseCoupon && (
            <SubscribeDialog
              personalUseCoupon={personalUseCoupon}
              Authorization={token.Authorization}
              personId={this.props.person.person.id}
              subscriberId={this.state.subscribers.id}
              subscriptionTypeId={this.state.subscribers.subscriptionTypeId}
            />
          )}
          {!isPISExists && <PisDialog />}
          {voucherCanBeUsed && (
            <UseVoucherDialog onClick={this.verifyVoucher} />
          )}


           <div className={PartnerStyles['program-container']}>
            {this.renderGpCard()}
          </div> 


          <div className={PartnerStyles['partner-activities']}>
            {this.renderCouponCard()}
            {this.renderRemuneracao()}
          </div>
        </div>
        {/* <a
            rel="noreferrer noopener"
            target="_blank"
            href="http://glamstar.com.br"
          > */}
        <div
          className={PartnerStyles['banner-glamstar']}
          onClick={() => this.Modal(GlamstarView)}
        />

        <Modal
          visible={this.state.GlamstarViewVisible}
          onCloseModal={this.Modal}
        >
          <div className={Style['details']}>
            <h3 className={Style['title']}>
              {currentDetails && currentDetails[0].title}
            </h3>
            <div>{currentDetails && currentDetails[0].details}</div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  person: state.person.data,
  partnerInfo: state.partnerInfo.data,
  partnerGeneral: state.partnerGeneral.data,
  partnerSales: state.partnerSales.data,
  insta: state.person.data.insta,
  token: state.token.data,
  subscribers: state.subscribers.data,
  partnerResults: state.partnerResults.data,
  loaded: state.loaded
});

const mapDispatchToProps = dispatch => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  getPartnerInfo: () => {
    dispatch(PartnerInfoActions.fetch());
  },
  toggle: name => {
    dispatch(ExecuteToggle(name));
  },
  getCurrentResults: () => {
    dispatch(PartnerResultsActions.getCurrentResults());
  },
});

PortalGlampartners = connect(
  mapStateToProps,
  mapDispatchToProps
)(PortalGlampartners);
